import { SurveyModel, surveyLocalization } from "survey-core";
import { parsePhoneNumberFromString } from "libphonenumber-js";

const translations: Record<string, Record<string, string>> = {
  en: {
    phoneMissingPlusError: "Phone number must start with a country code (e.g., +43, +49).",
    phoneInvalidError: "Please enter a valid phone number (e.g., +43 664 1234567)."
  },
  de: {
    phoneMissingPlusError: "Telefonnummer muss mit einer Landesvorwahl beginnen (z. B. +43, +49).",
    phoneInvalidError: "Bitte geben Sie eine gültige Telefonnummer ein (z. B. +43 664 1234567)."
  },
  hu: {
    phoneMissingPlusError: "A telefonszámnak országkóddal kell kezdődnie (pl. +43, +49).",
    phoneInvalidError: "Kérjük, adjon meg egy érvényes telefonszámot (pl. +43 664 1234567)."
  },
  sl: {
    phoneMissingPlusError: "Telefonska številka se mora začeti s klicno kodo države (npr. +43, +49).",
    phoneInvalidError: "Vnesite veljavno telefonsko številko (npr. +43 664 1234567)."
  },
  hr: {
    phoneMissingPlusError: "Telefonski broj mora početi s pozivnim brojem zemlje (npr. +43, +49).",
    phoneInvalidError: "Molimo unesite valjani telefonski broj (npr. +43 664 1234567)."
  }
};

// Register custom strings safely into surveyLocalization
Object.entries(translations).forEach(([lang, strings]) => {
  if (!surveyLocalization.locales[lang]) {
    surveyLocalization.locales[lang] = {};
  }
  Object.assign(surveyLocalization.locales[lang], strings);
});

export function applyCustomTelValidator(survey: SurveyModel): void {
  survey.onValidateQuestion.add((sender, options) => {
    if (options.question.getType() === 'text' && options.question.inputType === 'tel') {
      const value = (options.value || '').trim();

      if (!value) return;

      const currentLocale = sender.getLocale() || sender.locale;

      if (!value.startsWith('+')) {
        options.error = surveyLocalization.getString("phoneMissingPlusError", currentLocale);
        return;
      }

      try {
        const phoneNumber = parsePhoneNumberFromString(value);

        // Validate that it is a genuine phone number
        if (!phoneNumber || !phoneNumber.isValid()) {
          options.error = surveyLocalization.getString("phoneInvalidError", currentLocale);
        }
      } catch (e) {
        options.error = surveyLocalization.getString("phoneInvalidError", currentLocale);
      }
    }
  });
}